/* eslint-disable react-refresh/only-export-components */
import * as Sentry from "@sentry/react";
import posthog from "posthog-js";
import { env } from "@/shared/config/env";

export const POSTHOG_KEY = env.VITE_POSTHOG_KEY;

export function initPostHog() {
  if (!POSTHOG_KEY) return;

  posthog.init(POSTHOG_KEY, {
    api_host: env.VITE_POSTHOG_HOST,
    person_profiles: "identified_only",
    capture_pageview: false,
  });
}

const IS_PRODUCTION = import.meta.env.PROD;

export function initSentry() {
  if (!env.VITE_SENTRY_DSN) return;

  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: IS_PRODUCTION ? "production" : "development",
    release: __APP_VERSION__,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: IS_PRODUCTION ? 0.2 : 1.0,
    replaysSessionSampleRate: IS_PRODUCTION ? 0.1 : 0,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      if (event.exception && IS_PRODUCTION) {
        event.tags = { ...event.tags, platform: "tma" };
      }
      return event;
    },
  });

  const tgUser = window.Telegram?.WebApp?.initDataUnsafe?.user;
  if (tgUser) {
    Sentry.setUser({
      id: String(tgUser.id),
      username: tgUser.username ?? undefined,
    });
  }
}
